import { get, post, put } from './requests.js'

export const getTaxonomies = (params) => get(['taxonomies'], {}, params)

// Clones a taxonomy and all of its audiences. The cloned taxonomy and audiences
// land as draft. `payload` is { name, slug? } where slug is optional.
export const cloneTaxonomy = (id, payload) =>
  post(['taxonomies', 'clone', id], { removeTrailingSlash: true }, payload)

export const getTaxonomyAudiences = (slug, params) =>
  get(['taxonomies', slug, 'audiences'], { removeTrailingSlash: true }, params)

export const approveAllAudiences = (taxonomyId) =>
  put(['taxonomies', taxonomyId, 'approve-all'], { removeTrailingSlash: true }, {})

// Fetches the resolved mapping ids for a given taxonomy distribution.
// Returns: [{ _id, name, mapping_id }, ...]
export const getMappingIds = (taxonomyId, { mapping_ids, predictor_percentile_override }) =>
  get(
    ['taxonomies', taxonomyId, 'mapping-ids'],
    { transformPayload: false, removeTrailingSlash: true },
    { mapping_ids, predictor_percentile_override }
  )
